export const MACRO_TRENDS_WARNING_MESSAGE = 'Showing data for current year only; Not filter sensitive';
